import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader } from 'material-ui/Card';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';
import LocationIcon from 'material-ui/svg-icons/communication/location-on';


const VenueSegment = ({venue, location }) => {

    return  (
        <Card className="cent-card">
            <CardHeader
                title={<Link to={`/dashboard/venue/${venue.id}`}>{venue.name}</Link>}
                subtitle={<Link to={`/dashboard/location/${location.id}`}>{location.name}</Link>}
                avatar={<LocationIcon color={statusColours.default}/>}
            />
        </Card>
    );
};

VenueSegment.propTypes = {
    venue: PropTypes.object.isRequired,
};

export default VenueSegment;
